import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';
import * as _ from 'underscore';
import { DomSanitizer } from '@angular/platform-browser';
import { formatNumber } from '@angular/common';
import '@angular/common/locales/global/es';

@Pipe({
  name: 'toFixed',
})
export class toFixedFormat implements PipeTransform {
  transform(value: string, number: number) {
    if (_.isNumber(value)) return Number(value).toFixed(number);
    else return '';
  }
}

@Pipe({
  name: 'momentFormat',
})
export class momentFormat implements PipeTransform {
  transform(value: string, field: string) {
    if (value) return moment(value).format(field);
    else return '';
  }
}

@Pipe({
  name: 'sizeFormat',
})
export class sizeFormat implements PipeTransform {
  transform(fileSizeInBytes: number) {
    let i = -1;
    const byteUnits = [' kB', ' MB', ' GB', ' TB', 'PB', 'EB', 'ZB', 'YB'];
    do {
      fileSizeInBytes = fileSizeInBytes / 1024;
      i++;
    } while (fileSizeInBytes > 1024);

    return Math.max(fileSizeInBytes, 0.1).toFixed(1) + byteUnits[i];
  }
}

@Pipe({
  name: 'maxLength',
})
export class lengthFormat implements PipeTransform {
  transform(value: string, number: number) {
    if (value && value.length > number) return value.substr(0, number) + '...';
    else return value;
  }
}

@Pipe({
  name: 'ucFirst',
})
export class ucFirst implements PipeTransform {
  transform(string: string) {
    if (string) {
      return String(string).charAt(0).toUpperCase() + String(string).slice(1).toLowerCase();
    } else {
      return '';
    }
  }
}

@Pipe({
  name: 'join',
})
export class Join implements PipeTransform {
  transform(array) {
    const temp = [];
    if (array.length > 0) {
      array.forEach((val) => {
        if (val) {
          temp.push(val.name || val);
        }
      });
      return temp.join(',');
    }
  }
}

@Pipe({
  name: 'safeHtml',
})
export class SafeHtml implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) {}

  transform(html) {
    let toReturn = null;
    const doc = new DOMParser().parseFromString(html, 'text/html');
    if (doc) {
      toReturn = doc.getElementsByTagName('body')[0].innerHTML;
      return this.sanitizer.bypassSecurityTrustHtml(toReturn);
    }
  }
}

@Pipe({ name: 'label_by_id' })
// | label_by_id:value
// key = la clé de l'objet qui définit la date minimum
// value est la valeur de comparaison
// Si object[key] >= maxDate, on l'enleve de l'array
export class LabelByIdFilter implements PipeTransform {
  transform(array, value: number): string {
    let title = ''; // Si on a pas un array valable, alors ca ne vaut pas la peine;
    if (value !== null && value !== -1) {
      array.forEach((x) => {
        if (+value === +x['value']) {
          title = x['label'];
        }
      });
      return title;
    } else {
      return '/';
    }
  }
}

@Pipe({ name: 'label_by_array' })
// | label_by_id:value
// key = la clé de l'objet qui définit la date minimum
// value est la valeur de comparaison
// Si object[key] >= maxDate, on l'enleve de l'array
export class LabelByArrayFilter implements PipeTransform {
  transform(array, value): string {
    const temp = [];
    if (value.length > 0) {
      array.forEach((x) => {
        value.forEach((val) => {
          if (+val === +x['value']) {
            temp.push(x['label']);
          }
        });
      });
      return temp.join(', ');
    } else {
      return '/';
    }
  }
}

@Pipe({
  name: 'oppositeColor',
})
export class OppositeColor implements PipeTransform {
  transform(actualColor: string): string {
    if (actualColor) {
      const color = actualColor.charAt(0) === '#' ? actualColor.substring(1, 7) : actualColor;
      const r = parseInt(color.substring(0, 2), 16); // hexToR
      const g = parseInt(color.substring(2, 4), 16); // hexToG
      const b = parseInt(color.substring(4, 6), 16); // hexToB
      return r * 0.299 + g * 0.587 + b * 0.114 > 186 ? '#000000' : '#FFFFFF';
    }
  }
}

@Pipe({ name: 'replaceLineBreaks' })
export class ReplaceLineBreaks implements PipeTransform {
  transform(value: string): string {
    if (value) {
      return value.replace(/\n/, '<br>').replace(/\n/, '<br>');
    }
  }
}

@Pipe({ name: 'addIconForBreakTitle' })
export class AddIconForBreakTitle implements PipeTransform {
  transform(courrier, value: string): string {
    if (value === 'E') {
      return courrier + '<i class="icons-courrier_type_entrant_from_global_SCSS_biggerIcon ms-2"></i>';
    }
    if (value === 'S') {
      return courrier + '<i class="icons-courrier_type_sortant_from_global_SCSS_biggerIcon ms-2"></i>';
    }
    if (value === 'I') {
      return courrier + '<i class="icons-courrier_type_interne_from_global_SCSS_biggerIcon ms-2"></i>';
    }
  }
}

@Pipe({ name: 'addCharacterAtPosition' })
export class addCharacterAtPosition implements PipeTransform {
  transform(string, position: number, character: string, minimumSize: number) {
    let texte = null;

    if (string?.length >= minimumSize) {
      texte = string.toString();
      return texte.substr(0, position) + character + texte.substr(position, string.length);
    } else return string;
  }
}

@Pipe({ name: 'separateNumberWithCharacters' })
export class separateNumberWithCharacters implements PipeTransform {
  transform(string): string {
    // See https://en.wikipedia.org/wiki/Decimal_separator for more infos  => Example of use
    return formatNumber(string, 'es'); //es = Spain
  }
}
